module.exports = __webpack_public_path__ + "img/mind_background_1.7e459017.png";